import type { MultilinkStoryblok } from "~/types/storyblok";

export const useRedirect = () => {
  const route = useRoute();
  const { ssrContext } = useNuxtApp();
  const { start } = useLoadingIndicator();
  const nuxtApp = useNuxtApp();

  const getRedirect = (link: MultilinkStoryblok) => {
    return link?.url || link?.cached_url ? getLinkFieldUrl(link) : null;
  };

  const handleRedirects = (link: MultilinkStoryblok, statusCode: number = 301) => {
    const urlRedirect = link?.url || link?.cached_url ? getLinkFieldUrl(link) : null;

    if (urlRedirect) {
      console.log(`Attempting redirect to: ${urlRedirect} with status: ${statusCode}`);

      if (import.meta.server && ssrContext?.res) {
        nuxtApp.callHook("render:response", ({ event }) => {
          if (event.node.res === ssrContext.res) {
            console.log(`[Server Redirect ${statusCode}] ${route.fullPath} -> ${urlRedirect}`);
            event.node.res.writeHead(statusCode, { Location: urlRedirect });
            event.node.res.end();
          }
        });
        // Prevent further rendering on the server
        abortNavigation();
        return urlRedirect; // Indicate a redirect occurred
      } else {
        console.log(`[Client Redirect] Navigating to: ${urlRedirect}`);
        start({ force: true }); // Keep the loading indicator for client-side navigation
        navigateTo(urlRedirect, { external: link.linktype === "url" });
        return urlRedirect; // Indicate navigation occurred
      }
    }

    return false; // No redirect needed
  };

  return {
    getRedirect,
    handleRedirects,
  };
};
